import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-success-banner',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
  templateUrl: './success-banner.component.html',
  styleUrl: './success-banner.component.scss',
})
export class SuccessBannerComponent {
  readonly messageKey = input.required<string>();
  readonly messageParams = input<Record<string, unknown>>();
}
